import { createSlice } from '@reduxjs/toolkit';
import { getContentThunk } from "../../../../shared/model";
var initialState = {
  apperList: []
};
export var userSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    setCurrentApper: function setCurrentApper(state, action) {
      state.currentApper = action.payload;
    },
    setApperData: function setApperData(state, action) {
      state.apperData = action.payload;
    },
    setApperList: function setApperList(state, action) {
      state.apperList = action.payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(getContentThunk.fulfilled, function (state, _ref) {
      var _payload$data$AnimalW, _payload$data$AnimalW2;
      var payload = _ref.payload;
      state.apperList = (_payload$data$AnimalW = (_payload$data$AnimalW2 = payload.data.AnimalWeb) === null || _payload$data$AnimalW2 === void 0 ? void 0 : _payload$data$AnimalW2.content) !== null && _payload$data$AnimalW !== void 0 ? _payload$data$AnimalW : [];
    });
  }
});
var _userSlice$actions = userSlice.actions,
  setApperData = _userSlice$actions.setApperData,
  setCurrentApper = _userSlice$actions.setCurrentApper,
  setApperList = _userSlice$actions.setApperList;
export { setApperData, setCurrentApper, setApperList };